function byTypename<T extends { __typename: any }, V extends string & T["__typename"]>(lookingFor: V[]) {
  return (value: T): value is Extract<T, Record<"__typename", V>> => {
    return lookingFor.includes(value.__typename);
  };
}

export default function filterInUnionByTypename<T extends { __typename: string }, V extends string & T["__typename"]>(
  union: T[],
  lookingFor: V[],
) {
  return union.filter(byTypename(lookingFor));
}
